import { Component, OnInit } from '@angular/core';
import { Firestore, doc, updateDoc } from '@angular/fire/firestore';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { MenuAccountComponent } from '../../components/menu-account/menu-account';
import { FooterComponent } from '../../components/footer-main/footer-main';

// Import specific Ionic components
import { IonContent, IonHeader, IonToolbar, IonButtons, IonIcon, 
         IonTitle, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, 
         IonCardTitle, IonCardContent, IonCardSubtitle, IonButton, 
         IonItem, IonLabel, IonToggle, IonProgressBar, IonFooter } 
         from '@ionic/angular/standalone';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.page.html',
    styleUrls: ['./dashboard.page.scss'],
    standalone: true,
    host: { ngSkipHydration: 'true' },
    imports: [
        CommonModule,
        HeaderComponent,
        HeaderDesktopComponent,
        MenuAccountComponent,
        FooterComponent,
        RouterModule,
        // Register Ionic components
        IonContent, IonHeader, IonToolbar, IonButtons, IonIcon,
        IonTitle, IonGrid, IonRow, IonCol, IonCard, IonCardHeader,
        IonCardTitle, IonCardContent, IonCardSubtitle, IonButton,
        IonItem, IonLabel, IonToggle, IonProgressBar, IonFooter
    ]
})
export class DashboardPage implements OnInit {
  help: boolean = true;
  percent: number = 0;
  uid: string = '';

  constructor(
    public authService: AuthService, 
    private firestore: Firestore,
    private router: Router, 
  ) { }

  ngOnInit() {
    this.authService.user.subscribe(user => {
      if(user) {
        this.uid = user.uid;
        this.percent = 0;
        if (user.firstname) {
          this.percent += 10;
        }
        if (user.country) {
          this.percent += 10;
        }
        if (user.giglister) {
          this.percent += 5;
        }
        if (user.gigster) {
          this.percent += 5;
        }
        if (user.stripeAccountId) {
          this.percent += 5;
        }
        if (user.stripeAccount && user.stripeAccount.payouts_enabled) {
          this.percent += 5;
        }
        if (user.joblister) {
          this.percent += 5;
        }
        if (user.jobhunter) {
          this.percent += 5;
        }
        if (user.classification) {
          this.percent += 5;
        }
        if (user.experience) {
          this.percent += 5;
        }
        if (user.volseeker) {
          this.percent += 5;
        }
        if (user.overview) {
          this.percent += 5;
        }
        if (user.volunteer) {
          this.percent += 10;
        }
        if (user.promoter) {
          this.percent += 10;
        }
        if (user.customer) {
          this.percent += 10;
        }
      } else {
        this.router.navigate(['/login']);
      }
    })
  }
  
  private updateUserField(field: string, value: boolean) {
    const userRef = doc(this.firestore, `ge_users/${this.uid}`);
    return updateDoc(userRef, { [field]: value });
  }

  updateGigLister(value: boolean) {
    return this.updateUserField('giglister', value);
  }

  updateGigWorker(value: boolean) {
    return this.updateUserField('gigster', value);
  }

  updateJobLister(value: boolean) {
    return this.updateUserField('joblister', value);
  }

  updateJobHunter(value: boolean) {
    return this.updateUserField('jobhunter', value);
  }

  updateVolseeker(value: boolean) {
    return this.updateUserField('volseeker', value);
  }

  updateVolunteer(value: boolean) {
    return this.updateUserField('volunteer', value);
  }

  updatePromoter(value: boolean) {
    return this.updateUserField('promoter', value);
  }

  updateCustomer(value: boolean) {
    return this.updateUserField('customer', value);
  }
}
